import ScreenTitle from '@/features/quiz/screen-title'
import React, { PropsWithChildren } from 'react'

type Props = {
  header: Header
}

type Header = {
  title: string
  subtitle?: string | null
}

export default function QuizQuestionContainer({
  header,
  children,
}: PropsWithChildren<Props>) {
  return (
    <>
      <ScreenTitle title={header.title} subtitle={header.subtitle} />
      <div className="w-full">
        <div className="mx-auto max-w-3xl">
          <div className="flex flex-col gap-y-4 sm:gap-y-5 lg:gap-y-6">
            {children}
          </div>
        </div>
      </div>
    </>
  )
}
